module.exports = __webpack_public_path__ + "img/alarmas.8a112b88.jpg";